module.exports = __webpack_public_path__ + "a47368b41943f4e9fcb882a80c9e54ee.svg";